<template>
    <v-dialog v-model="visible" max-width="500" persistent>
        <v-card>
            <v-card-title class="headline grey lighten-3 font-weight-bold">
                <v-icon left class="mr-2" color="orange">mdi-alert</v-icon>
                ALERTAS DE LAS ENTREGAS
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text class="pt-4 pb-0">
                <v-alert v-if="upcomingDeliveries.length > 0" dense outlined type="warning" icon="mdi-truck-delivery" class="mb-3">
                    Entregas programadas:
                </v-alert>

                <v-list dense>
                    <v-list-item v-for="(venta, index) in newUpcomingDeliveries" :key="index" class="px-0">
                        <v-list-item-icon>
                            <v-icon color="orange">mdi-calendar-clock</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title class="text-body-2 font-weight-medium">
                                {{ venta.numeroComprobante }} - {{ `T-${venta.id}` }} - {{ `${venta.descEstado}` }}
                            </v-list-item-title>
                            <v-list-item-subtitle class="text-caption grey--text">
                                {{ venta.productos?.[0]?.description || 'Sin descripción' }}
                            </v-list-item-subtitle>
                            <v-list-item-subtitle class="text-caption">
                                Fecha entrega: <strong>{{ venta.check_in }}</strong>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="visible = false">Cerrar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            visible: false,
            message: ''
        }
    },
    computed: {
        ...mapGetters('ventas', ['upcomingDeliveries']),
        newUpcomingDeliveries() {
            const excluded = [8, 39, 42]
            console.log('upcomingDeliveries', this.upcomingDeliveries)
            return this.upcomingDeliveries.filter((e) => !excluded.includes(e.idEstado))
        }
    },
    methods: {
        showAlert(message) {
            this.message = message
            this.visible = true
        },
        generateMessage(orders) {
            return orders
                .map((venta) => {
                    const producto = venta.productos?.[0]?.description?.slice(0, 50) + '...' || 'Sin descripción'
                    const ticket = `T-${venta.id}`
                    return `• ${ticket} | ${producto} | ${venta.check_in}`
                })
                .join('\n')
        },
        checkIfShouldShowAlert(force = false) {
            const lastShown = localStorage.getItem('lastAlertTimestamp')
            const now = Date.now()
            console.log('Comprobando si se debe mostrar la alerta...')
            const entregas = this.upcomingDeliveries

            if ((force || !lastShown || now - Number(lastShown) > 2 * 60 * 60 * 1000) && entregas.length > 0) {
                const mensaje = this.generateMessage(entregas)
                this.showAlert(`⚠️ Entregas programadas:\n${mensaje}`)
                localStorage.setItem('lastAlertTimestamp', now)
            }
        }
    },
    watch: {
        upcomingDeliveries(newVal) {
            if (newVal && newVal.length > 0) {
                this.checkIfShouldShowAlert(true)
            }
        }
    },
    mounted() {
        console.log('GlobalAlert montado!')
        setInterval(() => {
            this.checkIfShouldShowAlert()
        }, 2 * 60 * 60 * 1000) // cada 2 horas
    }
}
</script>
